import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router';
import {useCreatePublication} from '../client.js';
import {cleanPublication} from '../utils.js';
import Page from './Page.jsx';
import PublicationForm from './form/PublicationForm.jsx';

function NewPublication() {
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState('');
  const {request, loading, error, data} = useCreatePublication();

  const onSubmit = data => {
    if (loading) {
      return;
    }

    request(cleanPublication(data));
  };

  useEffect(() => {
    if (loading || !data) {
      return;
    }
    if (error) {
      setErrorMessage(data.message || error.message);
      return;
    }
    navigate(`/publications/${data.id}`);
  }, [data, error, loading, navigate]);

  return (
    <Page title="New Publication">
      <Box
        sx={{
          marginBottom: 2,
        }}
      >
        <Typography variant="h6">New Publication</Typography>
      </Box>
      {errorMessage && (
        <Alert sx={{marginTop: 1, marginBottom: 1}} severity="error">
          {errorMessage}
        </Alert>
      )}
      <PublicationForm onSubmit={onSubmit} />
    </Page>
  );
}

export default NewPublication;
